import React from "react";
import { notify } from "@/shared/utils/notify";
import { rulesApplyFiftyPercentDiscount } from "../../../shared/services";
import { IRulesSushiLunch } from "../../../redux/@types";

export const useRulesFiftyOffList = () => {
  const [loading, setLoading] = React.useState(false);
  const [rules, setRules] = React.useState<IRulesSushiLunch[]>([]);
  const [refreshKey, setRefreshKey] = React.useState(0);

  const loadRules = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await rulesApplyFiftyPercentDiscount.find({
        query: {
          $sort: { id: -1 },
          $limit: 100,
        },
      });
      setRules(res.data || []);
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refresh = () => {
    setRefreshKey((prev) => prev + 1);
  };

  React.useEffect(() => {
    loadRules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  return {
    loading,
    rules,
    refresh,
  };
};
